import { ComputerUsersPublishersAppsMembership, Folders, ProfilePrivilege, UserGroupAccess } from './../resourceInterface';
import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { myLocalStorage } from "../../../StorageHelper";
import { Publishers, ResourceAPP, URLControl, User } from "../resourceInterface";

export const getUsers = async (
  email: string,
  tenantName: string,
  computerId: string,
  role: string,
  isOwnComputer: boolean = false,
  deviceHasAccess: boolean = false,
  userRole: string,
  isSShBased: boolean = false,
  userApprovedNotifications: any[]
): Promise<any[] | undefined> => {
  try {

    if (!email || !tenantName || !computerId) return;


    if (
      role === "TENANT_ADMIN" ||
      role === "SYS_ADMIN" ||
      (role === "TENANT_USER" && isSShBased && deviceHasAccess) ||
      (userRole !== "thirdparty-user" && (isOwnComputer || myLocalStorage.getItem("azuresso")))
    ) {


      if (
        role === "TENANT_USER" &&
        isSShBased &&
        deviceHasAccess
      ) {
        let url = `${NGROK}/api/adcomputer/users/${tenantName}/published/computer-user?computerId=${computerId}&email=${email}`;
        const response = await apiClient<any>({
          method: "GET",
          url,
        });
        const fetchResourceLevel = userApprovedNotifications?.filter(
          (userNotification) =>
            String(userNotification.computerId) === String(computerId) &&
            userNotification.requestStatus === "APPROVED" &&
            userNotification.resourceType === "GROUP" &&
            userNotification.resourceName === "Whiteswan Access",
        );
        const matchedUsers = response.filter((user: any) =>
          fetchResourceLevel.some(
            (resource) => resource.machineUser === user.cn,
          ),
        );
        return matchedUsers;

      } else {
        let url = `${NGROK}/api/${tenantName}/computer-users/${computerId}`;

        const response = await apiClient<any>({
          method: "GET",
          url,
        });

        if (response?.content) {
          let users = response.content;

          if (
            userRole === "epam-user" ||
            userRole === "server-pam-user" ||
            userRole === "developer-user" ||
            userRole === "thirdparty-user"
          ) {
            users = users.filter((user: User) => user.cn !== "wsadmin");
          }

          const uniqueUsers: User[] = [];
          const seenEmails = new Set<string>();

          for (const user of users) {
            if (!seenEmails.has(user.email)) {
              seenEmails.add(user.email);
              uniqueUsers.push(user);
            }
          }

          return uniqueUsers;
        }

      }
    } else if (role === "TENANT_USER") {
      let url = `${NGROK}/api/${tenantName}/computer-users/${computerId}/users?email=${email}`;

      if (!isSShBased) {
        const fetchResourceLevel = userApprovedNotifications?.filter(
          (userNotification) =>
            String(userNotification.computerId) === String(computerId) &&
            userNotification.requestStatus === "APPROVED" &&
            userNotification.resourceType === "GROUP" &&
            userNotification.resourceName === "Whiteswan Access",
        );

        const response = await apiClient<any>({
          method: "GET",
          url: `${NGROK}/api/${tenantName}/computer-users/${computerId}`,
        });
        if (response?.content) {
          let content = response.content;
          console.log(fetchResourceLevel, content)
          const isValidUser = content.find(
            (user: any) => user.cn === fetchResourceLevel[0]?.connectionUser,
          );
          if (isValidUser) {
            myLocalStorage.setItem("latestUser", isValidUser);

            url = `${NGROK}/api/${tenantName}/computer-users/${computerId}/users?email=${isValidUser.email}`;
          }
        }
      }

      const content = await apiClient<any>({
        method: "GET",
        url,
      });
      const uniqueUsers = [];
      const seenEmails = new Set();

      for (const user of content) {
        if (!seenEmails.has(user.email)) {
          seenEmails.add(user.email);
          uniqueUsers.push(user);
        }
      }
      return uniqueUsers;


    }

    return [];
  } catch (error) {
    console.error("getUsers error:", error);
  }
};



export const addFolderToUser = async (
  folder: { computerUserId: number; folderId: number },
  groupStatus: string,
  inputTime: number,
  tenantName: string,
  activeComputer: any,
  userData: { email: string; role: string }
) => {
  const timeInSeconds = (inputTime || activeComputer.defaultTime) * 60;

  return await apiClient<any>({
    method: "PUT",
    url: `${NGROK}/api/${tenantName}/computer-user/folders/timer`,
    data: {
      userId: folder.computerUserId,
      folderId: folder.folderId,
      email: userData.email,
      role: userData.role,
      groupStatus,
      selectedTime: timeInSeconds,
      computerId: activeComputer?.id,
    },
  });
};



export const getFoldersForProfile = async (
  profileId: number,
  os: string) => {
  const response = await apiClient<any>({
    method: "GET",
    url: `${NGROK}/api/${os}/profiles/${profileId}/folders`,
  });
  if (response) {
    return response.content;
  }
  return [];
};

export const getFolders = async (
  tenantName: string,
  activeComputerId: string,
  selectedUserId: string
) => {
  const response = await apiClient<any>({
    method: "GET",
    url: `${NGROK}/api/${tenantName}/computers/${activeComputerId}/computer-users/${selectedUserId}/folders`,
  });
  if (response) {
    return response.content;
  }
  return [];
};


export const fetchUrlControlDataWithProfile = async (
  profileId: number,
  os: string
): Promise<URLControl[]> => {
  try {
    const response = await apiClient<{ content: URLControl[] }>({
      method: "GET",
      url: `${NGROK}/api/${os}/profiles/${profileId}/url-control`,
    });

    if (response?.content) {
      const sortedUrls = response.content.sort(
        (a, b) => (a.urlId ?? 0) - (b.urlId ?? 0)
      );
      return sortedUrls;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const fetchUrlControlData = async (
  tenantName: string,
  activeComputerId: string,
  selectedUserId: string
): Promise<URLControl[]> => {
  try {
    const response = await apiClient<{ content: URLControl[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computers/${activeComputerId}/computer-users/${selectedUserId}/url-control`,
    });

    if (response?.content) {
      const sortedUrls = response.content.sort(
        (a, b) => (a.urlId ?? 0) - (b.urlId ?? 0)
      );
      return sortedUrls;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const getPublishersWithProfiles = async (
  os: string,
  profileId: number
): Promise<Publishers[]> => {
  try {
    const response = await apiClient<{ content: Publishers[] }>({
      method: "GET",
      url: `${NGROK}/api/${os}/profiles/${profileId}/publishers`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const getPublishers = async (
  tenantName: string,
  activeComputerId: string
): Promise<Publishers[]> => {
  try {
    const response = await apiClient<{ content: Publishers[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computers/${activeComputerId}/publishers`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const getAllAppsWithProfile = async (
  profileId: number,
  page: number = 0,
  limit: number = 100,
  privilegeFilter: string = "",
  searchParams: string = ""
): Promise<ResourceAPP[]> => {
  try {


    const response = await apiClient({
      method: "GET",
      url: `${NGROK}/api/profiles/get-all-apps?profileId=${profileId}&page=${page}&limit=${limit}&privilegeFilter=${privilegeFilter}&searchParams=${searchParams}`,
    });

    if (response) {
      return response;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const getAllAppsWithProfileSearch = async (
  profileId: number,
  searchParams: string,
  page: number = 0,
  limit: number = 100,
  privilegeFilter: string = ""
): Promise<ResourceAPP[]> => {
  try {

    let url = `${NGROK}/api/profiles/get-all-apps?profileId=${profileId}&page=${page}&limit=${limit}&privilegeFilter=${privilegeFilter}`;
    if (searchParams.length > 0) {
      url += `&searchParams=${searchParams}`
    }
    const response = await apiClient({
      method: "GET",
      url: url,
    });

    if (response) {
      return response;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};

export const getAppsForPublishersCount = async (tenantName: string,
  selectedUserId: string,
  selectedPublisherId: number,
  searchParams: string,
  privilegeFilter: string = ""): Promise<any> => {

  try {
    const response = await apiClient<{ content: ResourceAPP[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computer-users/${selectedUserId}/publishers/${selectedPublisherId}/apps/count?privilegeFilter=${privilegeFilter}&searchParams=${searchParams}`,
    });

    return response || 0;
  } catch (error) {
    console.error("Failed to fetch apps for publishers count:", error);
    return 0;
  }
};


export const getAllAppsCount = async (
  activeComputerId: string,
  selectedUserId: string,
  searchParams: string,
  privilegeFilter: string = ""
): Promise<any> => {
  try {

    const response = await apiClient<{ content: ResourceAPP[] }>({
      method: "GET",
      url: `${NGROK}/api/computer-user/get-all-apps/count?userId=${selectedUserId}&computerId=${activeComputerId}&searchParams=${searchParams}&privilegeFilter=${privilegeFilter}`,
    });

    return response || 0;
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return 0;
  }
};


export const getAllApps = async (
  activeComputerId: string,
  selectedUserId: string,
  searchParams: string,
  page: number = 0,
  limit: number = 100,
  privilegeFilter: string = ""
): Promise<ResourceAPP[]> => {
  try {

    const response = await apiClient<{ content: ResourceAPP[] }>({
      method: "GET",
      url: `${NGROK}/api/computer-user/get-all-apps?userId=${selectedUserId}&computerId=${activeComputerId}&page=${page}&limit=${limit}&searchParams=${searchParams}&privilegeFilter=${privilegeFilter}`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const getAppsForPublishersWithProfile = async (
  profileId: number,
  os: string,
  tenantName: string,
  selectedPublisherId: number,
  page: number = 0,
  limit: number = 100,
  privilegeFilter: string = "",
  searchParams: string = ""
): Promise<ResourceAPP[]> => {
  try {


    const response = await apiClient<{ content: ResourceAPP[] }>({
      method: "GET",
      url: `${NGROK}/api/${os}/profiles/${profileId}/publishers/${selectedPublisherId}/apps?page=${page}&limit=${limit}&privilegeFilter=${privilegeFilter}&searchParams=${searchParams}`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const getAppsForPublishers = async (
  tenantName: string,
  selectedUserId: string,
  selectedPublisherId: number,
  privilegeFilter: string = "",
  searchParams: string = ""
): Promise<ResourceAPP[]> => {
  try {

    const response = await apiClient<{ content: ResourceAPP[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computer-users/${selectedUserId}/publishers/${selectedPublisherId}/apps?privilegeFilter=${privilegeFilter}&searchParams=${searchParams}`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const updateTrustLevelForProfile = async (
  app: any,
  newStatus: string,
  email: string,
  role: string,
  profileId: number
): Promise<any[]> => {
  const payload = {
    appId: app.appId,
    email: email,
    fingerprintSha256: app.fingerprintSha256,
    profileId: profileId,
    groupStatus: newStatus,
    tenantName: myLocalStorage.getItem("latestTenant").tenantName || app.tenantName
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/profiles/apps/update`,
    data: payload,
  });

  return response;
};



export const updateTrustLevel = async (
  app: ComputerUsersPublishersAppsMembership,
  newStatus: string,
  tenantName: string,
  selectedUserId: string,
  email: string,
  role: string,
  timeInSeconds: number
): Promise<any[]> => {
  const payload = {
    userId: Number(selectedUserId),
    publisherId: Number(app.publisherId),
    appId: app.appId,
    email: email,
    role: role,
    groupStatus: newStatus,
    selectedTime: timeInSeconds,
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/${tenantName}/computer-user/publishers/apps/timer`,
    data: payload,
  });

  return response;
};

export const updateFolderTrustLevelforProfile = async (
  profileId: number,
  app: Folders,
  newStatus: string,
  tenantName: string,
  email: string,
  role: string,
): Promise<any[]> => {
  const payload = {
    profileId: profileId,
    folderId: app.folderId,
    email: email,
    role: role,
    groupStatus: newStatus,
    selectedTime: 10800,
    tenantName: tenantName
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/profiles/folders/update`,
    data: payload,
  });

  return response;
};

export const updateFolderTrustLevel = async (
  deviceId: string,
  app: Folders,
  newStatus: string,
  tenantName: string,
  selectedUserId: string,
  email: string,
  role: string,
  timeInSeconds: number
): Promise<any[]> => {
  const payload = {
    computerId: deviceId,
    userId: Number(selectedUserId),
    folderId: app.folderId,
    email: email,
    role: role,
    groupStatus: newStatus,
    selectedTime: timeInSeconds,
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/${tenantName}/computer-user/folders/timer`,
    data: payload,
  });

  return response;
};


export const getPriviledgeManagement = async (
  tenantName: string,
  selectedUserId: string,
  selectedPublisherId: number
): Promise<UserGroupAccess[]> => {
  try {
    const response = await apiClient<{ content: UserGroupAccess[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computer-users/${selectedUserId}/publishers/${selectedPublisherId}/apps`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const getPrivilegeMgmtForUsers = async (
  userId: string,
  tenantName: string
): Promise<any[]> => {
  try {
    const response = await apiClient<{ content: any[] }>({
      method: "GET",
      url: `${NGROK}/api/${tenantName}/computer-user-groups/membership/${userId}`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};



export const getPrivilegeMgmtForProfile = async (
  profileId: number,
  os: string
): Promise<ProfilePrivilege[]> => {
  try {
    const response = await apiClient<{ content: ProfilePrivilege[] }>({
      method: "GET",
      url: `${NGROK}/api/${os}/profiles/${profileId}/membership`,
    });

    if (response?.content) {
      return response?.content;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const updatePriviledgeForProfiles = async (
  email: string,
  groupId: number,
  newStatus: string,
  profileId: number,
  tenantName: string
): Promise<any[]> => {
  const payload = {
    groupId: groupId,
    profileId: profileId,
    email: email,
    groupStatus: newStatus,
    selectedTime: 10800,
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/profiles/groups/update`,
    data: payload,
  });

  return response;
};


export const updatePriviledgeForUsers = async (
  email: string,
  groupId: number,
  newStatus: string,
  tenantName: string,
  deviceId: string,
  role: string,
  userId: string,
  timeInSeconds: number
): Promise<any[]> => {
  const payload = {
    groupId: groupId,
    email: email,
    groupStatus: newStatus,
    selectedTime: timeInSeconds,
    role: role,
    userId: userId
  };

  const response = await apiClient<any[]>({
    method: "PUT",
    url: `${NGROK}/api/${tenantName}/computer-user-groups/membership?computerId=${deviceId}`,
    data: payload,
  });

  return response;
};



export const getTotalAppsCount = async (
  profileId: number,
  searchParams: string,
  selectedPublisher: number,
  os: string,
  privilegeFilter: string = ""
): Promise<any> => {
  try {

    let url = `${NGROK}/api/profiles/get-all-apps/count?profileId=${profileId}&page=0&limit=1000&privilegeFilter=${privilegeFilter}`;

    if (selectedPublisher !== -1) {
      url = `${NGROK}/api/${os}/profiles/${profileId}/publishers/${selectedPublisher}/apps/count?page=0&limit=1000&privilegeFilter=${privilegeFilter}`;
    }
    if (searchParams.length > 0) {
      url += `&searchParams=${searchParams}`
    }
    const response = await apiClient({
      method: "GET",
      url: url,
    });


    if (response) {
      return response;
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch URL control data:", error);
    return [];
  }
};


export const addURL = async (tenantName: string, urlname: string, computerId: string, email: string) => {
  let url = `${NGROK}/api/kafka/ui/url-control`;
  let payload = {
    tenant_name: tenantName,
    computer_id: computerId,
    data: [
      {
        name: urlname,
        Ips: ["142.250.196.14"],
        reputation_score: 85,
        email: email,
      },
    ],
  }
  const response = await apiClient({
    method: "POST",
    url: url,
    data: payload
  });
  return response;

}

export const deleteTheURL = async (urlId: number) => {
  let url = `${NGROK}/api/url-control/${urlId}`;
  const response = await apiClient({
    method: "DELETE",
    url: url
  });
  return response;

}


export const updateURLTrustLevel = async (payload: any, tenantName: string) => {
  let url = `${NGROK}/api/${tenantName}/computer-user/url-control/timer`;
  const response = await apiClient({
    method: "PUT",
    url: url,
    data: payload
  });
  return response;
}

export const updateURLTrustLevelForProfile = async (
  payload: {
    urlId: number;
    profileId: number;
    groupStatus: string;
    email: string;
    role: string;
    tenantName: string;
  }
) => {
  const response = await apiClient({
    method: "PUT",
    url: `${NGROK}/api/profiles/url-control/update`,
    data: payload,
  });

  return response;
}
